import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/RoomTypeItemBox.styles'

const RoomTypeItemBoxSkeleton = () => {
  const classes = useStyles()
  return (
    <div>
      <div className={classes.itemBox}>
        <Typography variant="h4" className={classes.title}>
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
        <div className={classes.codeMappingContianer}>
          <div className={classes.skeletonContainer}>
            <Skeleton animation="wave" className={classes.Subskeleton} />
          </div>
          <div className={classes.skeletonContainer}>
            <Skeleton animation="wave" className={classes.Subskeleton} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoomTypeItemBoxSkeleton
